import { Department } from '../../lib/woocomerce/__generated__/graphql';
import { Box, useResponsiveConditional } from '@biom3/react';

type DepartmentButtonProps = {
  // eslint-disable-next-line no-unused-vars
  onSelect: (department: Partial<Department>) => void;
  department: Partial<Department>;
  selectedDepartment?: Department;
};

export const DepartmentButton = ({
  onSelect,
  department,
  selectedDepartment
}: DepartmentButtonProps) => {
  const isMediumScreenOrAbove = useResponsiveConditional('medium');
  return (
    <Box
      key={department.id}
      onClick={() => onSelect(department)}
      sx={{
        borderRadius: 'base.borderRadius.x5',
        padding: 'base.spacing.x1',
        height: 'base.spacing.x20',
        position: 'relative',
        background:
          selectedDepartment?.id === department.id ? 'base.gradient.1' : 'base.gradient.4',
        boxShadow: selectedDepartment?.id === department.id ? 'base.shadow.500' : 'unset'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          overflow: selectedDepartment?.id === department.id ? 'hidden' : 'unset',
          display: 'flex',
          alignItems: 'center',
          borderRadius: 'base.borderRadius.x4',
          height: '100%',
          width: '100%',
          background: selectedDepartment?.id === department.id ? 'base.gradient.3' : 'transparent'
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            marginLeft: 'base.spacing.x4',
            color:
              selectedDepartment?.id === department.id
                ? 'base.color.accent.1'
                : 'base.color.accent.2',
            fontSize: 'base.text.heading.medium.regular.fontSize',
            fontFamily: 'base.font.family.heading.primary',
            zIndex: 3,
            textShadow: '0 0 4px black'
          }}
        >
          {department.name}
        </Box>
        {isMediumScreenOrAbove && (
          <Box
            sx={{
              position: 'absolute',
              width: ({ base }) => `calc(100% + ${base.spacing.x2})`,
              height: ({ base }) => `calc(100% + ${base.spacing.x2})`,
              right: ({ base }) => `-${base.spacing.x1}`,
              filter: `saturate(${selectedDepartment?.id === department.id ? '1' : '0.3'})`,
              zIndex: 2,
              backgroundImage: `url(${department.image?.sourceUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'right'
            }}
          />
        )}
        {selectedDepartment?.id === department.id && (
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              filter: `saturate(${selectedDepartment?.id === department.id ? '1' : '0.4'})`,
              zIndex: 1,
              backgroundImage: `url(/images/sparkles.png)`,
              backgroundSize: 'cover',
              backgroundPosition: 'right'
            }}
          />
        )}
      </Box>
    </Box>
  );
};
